export const MODALITIES = [
  'Breathwork',
  'Calisthenics',
  'Functional Movement',
  'Meditation',
  'Other',
  'Pilates',
  'QiGong/Tai Chi',
  'Somatic Movement',
  'Soundbath',
  'Yoga',
] as const;

export type ModalityT = typeof MODALITIES[number];

export const MODALITY_COLORS: Record<ModalityT, string> = {
  Breathwork: '#FFB108',
  Calisthenics: '#AD020E',
  'Functional Movement': 'black',
  Meditation: '#529AFF',
  Other: 'black',
  Pilates: '#85C01F',
  'QiGong/Tai Chi': '#3A3897',
  'Somatic Movement': 'black',
  Soundbath: 'black',
  Yoga: '#E227FF',
};
